import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JobPage } from './job';

import { RcsKdJobDetailComponent } from '../../components/rcs-kd-job-detail/rcs-kd-job-detail';
import { RcsKdJobOfferComponent } from '../../components/rcs-kd-job-offer/rcs-kd-job-offer';

import { SignaturePadModule } from 'angular2-signaturepad';

@NgModule({
  declarations: [
    JobPage,
    RcsKdJobDetailComponent,
    RcsKdJobOfferComponent,
  ],
  imports: [
    SignaturePadModule,
    IonicPageModule.forChild(JobPage),
  ],
  exports: [
    JobPage,
  ]
})
export class JobPageModule {}



// WEBPACK FOOTER //
// ./src/pages/job/job.module.ts